import useClientRepository from "../../../../../../repository/insurance/useClientRepository";
import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import {TextField} from "@mui/material";
import Box from "@mui/material/Box";

export default function ({clientId, onEmailChange, onPhoneMobileChange}) {
    const clientRepository = useClientRepository();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();

    useEffect(() => {
        clientRepository.findOneById(clientId).exec();
    }, []);

    useEffect(() => {
        if (isNull(client)) return;

        onEmailChange(client.getEmail());
        onPhoneMobileChange(client.getPhoneMobile());
    }, [JSON.stringify(client)]);

    if (isNull(client)) return null;

    return (
        <>
            <div>
                <TextField
                    fullWidth
                    variant={"standard"}
                    label={"Téléphone du sociétaire"}
                    defaultValue={client.getPhoneMobile()}
                    onChange={e => onPhoneMobileChange(e.target.value)}
                    data-test="insurance-input-client-phone"
                />
            </div>
            <Box mt={2}>
                <TextField
                    fullWidth
                    variant={"standard"}
                    label={"Email du sociétaire"}
                    defaultValue={client.getEmail()}
                    onChange={e => onEmailChange(e.target.value)}
                    data-test="insurance-input-client-email"
                />
            </Box>
        </>
    );
}
